<div class="container-block-cod h-[70%] max-h-[70%] overflow-y-auto rounded-lg border border-gray-400 bg-gray-100 p-4">
  @if (this.runningConfig && this.runningConfig.running_config) {
  <div [innerHTML]="this.sanitizeHtml(this.runningConfig.running_config)"></div>
  }
</div>
